import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  SelectFormField,
  DateFormField,
  RadioFormField
} from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions, selectDocsAllOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper, StepperFormRow } from "@components";
import { yesNo } from "@config/StepperForm";
import { useWatch } from "react-hook-form";

export const ClientCeo = ({ control, resetOtherCeoPlace }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  const otherCeoCitizen = useWatch({ control, name: "clientCeo.0.data.otherCeoCitizien" });
  const docsAll = useSelector(selectDocsAllOptions);

  return (
    <>
      <StepperFormRow>
        <FullWidthInputWrapper>
          <p className="form-group-title">{trb(i18.Labels.ClientCeo)}</p>
        </FullWidthInputWrapper>

        <HalfWidthInputWrapper>
          <InputFormField
            control={control}
            name="clientCeo.0.data.clientCeoName"
            title={trb(i18.Labels.ClientCeoName)}
          />
        </HalfWidthInputWrapper>

        <HalfWidthInputWrapper>
          <InputFormField
            control={control}
            name="clientCeo.0.data.clientCeoSurname"
            title={trb(i18.Labels.ClientSurname)}
          />
        </HalfWidthInputWrapper>

        <HalfWidthInputWrapper>
          <InputFormField
            control={control}
            name="clientCeo.0.data.clientCeoId"
            title={trb(i18.Labels.ClientId)}
          />
        </HalfWidthInputWrapper>

        <HalfWidthInputWrapper>
          <SelectFormField
            control={control}
            name="clientCeo.0.data.clientCeoCitizien"
            title={trb(i18.Labels.ClientCeoCitizien)}
            options={availableCountries}
            optionsLabel="label"
            optionsValue="value"
            isSearchable
            defaultValue="LT"
          />
        </HalfWidthInputWrapper>

        <HalfWidthInputWrapper>
          <DateFormField
            control={control}
            name="clientCeo.0.data.managerBirthDate"
            title={trb(i18.Labels.ClientCeoBirthDate)}
            maxDate={new Date()}
          />
        </HalfWidthInputWrapper>

        <FullWidthInputWrapper>
          <RadioFormField
            control={control}
            name="clientCeo.0.data.otherCeoCitizien"
            title={trb(i18.Labels.OtherCeoCitizien)}
            options={yesNo}
            optionsLabel="label"
            optionsValue="value"
            onChange={resetOtherCeoPlace}
            defaultValue={0}
            translationGroup={i18.Labels}
          />
        </FullWidthInputWrapper>
      </StepperFormRow>
      <StepperFormRow>
        {(otherCeoCitizen === 1 || otherCeoCitizen === "1") && (
          <>
            <FullWidthInputWrapper>
              <SelectFormField
                control={control}
                name="clientCeo.0.data.otherCeoCitDocTy"
                title={trb(i18.Labels.ClientId)}
                options={docsAll}
                optionsLabel="label"
                optionsValue="value"
                isSearchable
                defaultValue="DOCS6"
              />
            </FullWidthInputWrapper>

            <FullWidthInputWrapper>
              <InputFormField
                control={control}
                name="clientCeo.0.data.otherCeoCitDocNo"
                title={trb(i18.Labels.OtherCeoCitDocNo)}
              />
            </FullWidthInputWrapper>

            <FullWidthInputWrapper>
              <SelectFormField
                control={control}
                name="clientCeo.0.data.otherCeoCitDocCountry"
                title={trb(i18.Labels.OtherCeoCitDocCountry)}
                options={availableCountries}
                optionsLabel="label"
                optionsValue="value"
                isSearchable
                defaultValue="LT"
              />
            </FullWidthInputWrapper>
            <FullWidthInputWrapper>
              <RadioFormField
                control={control}
                name="clientCeo.0.data.otherCeoCitizienSch"
                title={trb(i18.Labels.OtherCeoCitizienSch)}
                options={yesNo}
                translationGroup={i18.Labels}
                optionsLabel="label"
                optionsValue="value"
                defaultValue={0}
              />
            </FullWidthInputWrapper>
          </>
        )}
      </StepperFormRow>
    </>
  );
};
